import axios from 'axios';

// 스토어는 나중에 동적으로 설정
let store = null;

// 스토어 설정 함수
export const setStore = storeInstance => {
  store = storeInstance;
  // 스토어가 설정된 후 baseURL 업데이트
  if (store && store.state && store.state.backend_host) {
    authApi.defaults.baseURL = store.state.backend_host;
    publicApi.defaults.baseURL = store.state.backend_host;
    v3Api.defaults.baseURL = store.state.backend_host + '/v3';
  }
};

// 초기화 상태 관리
export const setInitializing = status => {
  isInitializing = status;
};

// 인증이 필요한 API 인스턴스
export const authApi = axios.create({
  baseURL: process.env.VUE_APP_BACKENDHOST,
  withCredentials: true, // HttpOnly 쿠키 전송을 위해 필요
  headers: {
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
    Expires: '0'
  }
});

// 공개 API 인스턴스 (인증 불필요)
export const publicApi = axios.create({
  baseURL: process.env.VUE_APP_BACKENDHOST,
  withCredentials: true, // 일관성을 위해 추가
  headers: {
    'Cache-Control': 'default'
  }
});

// V3 환경용 헤더 없는 API 인스턴스
export const v3Api = axios.create({
  baseURL: process.env.VUE_APP_BACKENDHOST + '/v3',
  withCredentials: true
});

// 세션 갱신 중복 요청 방지를 위한 플래그
let isRefreshing = false;
let failedQueue = [];
let isInitializing = false;

export const processQueue = error => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve();
    }
  });

  failedQueue = [];
};

// 인증 API 요청 인터셉터 (쿠키 기반이므로 토큰 처리 불필요)
authApi.interceptors.request.use(
  config => {
    // ✅ localStorage에서 토큰 가져와서 Authorization 헤더에 추가
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// v3Api 요청 인터셉터 (토큰 추가)
v3Api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// 인증 API 응답 인터셉터 - 401 에러 시 세션 갱신 재시도
authApi.interceptors.response.use(
  response => {
    // 응답에 새 토큰이 있으면 localStorage 업데이트
    if (response.data && response.data.access_token && store) {
      store.commit('setAccessToken', response.data.access_token);
    }
    return response;
  },
  async error => {
    const originalRequest = error.config;

    // 401 에러이고, refresh 요청이 아니며, 아직 재시도하지 않은 경우
    if (
      error.response?.status === 401 &&
      !originalRequest.url?.includes('/refresh') &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      if (isRefreshing) {
        // 이미 세션 갱신 중인 경우 대기
        console.log('401 에러 - 세션 갱신 대기 중...');
        return new Promise((resolve, reject) => {
          failedQueue.push({
            resolve: () => {
              resolve(authApi(originalRequest));
            },
            reject
          });
        });
      }

      isRefreshing = true;

      try {
        // refresh 요청 (쿠키는 자동으로 전송됨)
        // baseURL은 axios 인스턴스 생성 시 이미 설정되어 있음
        const response = await authApi.post('/auth/refresh', {});

        if (response?.data.code) {
          // ✅ 새 토큰이 응답에 있으면 저장
          if (response.data.access_token) {
            localStorage.setItem('access_token', response.data.access_token);
          } else {
            localStorage.removeItem('access_token');
          }

          processQueue(null);
          isRefreshing = false;

          // 원래 요청 재시도 (쿠키는 자동으로 전송됨)
          return authApi(originalRequest);
        } else {
          throw new Error('Session refresh failed');
        }
      } catch (refreshError) {
        console.log('401 에러 후 세션 갱신 실패:', refreshError.message);
        processQueue(refreshError);
        isRefreshing = false;

        // 로그인 페이지로 리다이렉트
        if (window.location.pathname !== '/login' && window.location.pathname !== '/') {
          window.location.href = '/';
        }

        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

// 공개 API 응답 인터셉터 (기본 에러 처리만)
publicApi.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);
